import { ManagerUpdatesPagePublishedInvestmentManagerUpdatesQuery } from '@/__generated__/graphql';
import { IFilterBarData } from '../basicComponents/filterBar';
import { Investment } from '../dealCatalog-page/types';

export interface IListInvestmentsForManagerUpdateQuery {
  total: number;
  page: number;
  perPage: number;
  filters: IFilterBarData[];
  data: Investment[];
}

export type PublishedInvestmentManagerUpdatesDto =
  ManagerUpdatesPagePublishedInvestmentManagerUpdatesQuery['publishedInvestmentManagerUpdates'][number];

export enum PublishedInvestmentManagerUpdatesSourceEnum {
  MANAGER_UPDATES = 'managerUpdates',
  UPDATES_TAB = 'updatesTab'
}

export type DocumentRecordSentimentFlag = 'Positive' | 'Negative' | 'Neutral';
